export default "__VITE_ASSET__BuVOQtD0__"